<template>
  <div class="card" style="max-width:340px;margin:10px;">
    <h5 class="card-title">Eigenschaften Knoten</h5>
    <span class="text-muted">{{ node.id }}</span>
    <div class="btn-toolbar" role="toolbar">
      <button @click="updateData" class="btn btn-sm btn-primary">Update</button>
    </div>
    <div class="form-group">
      <label>Name</label>
      <input type="text" class="form-control" v-model="node.name"/>
    </div>
    <div class="form-group">
      <label>Start-Bedingung</label>
      <input type="text" class="form-control" v-model="node.condition"/>
      <small class="form-text text-muted">Basisobject: startevent</small>
    </div>
    <div class="btn-group">
      <button @click="selectEvent" class="btn btn-primary">Event wählen...</button>
      <a href="/trendshop.proxy.web/events/" target="_blank"><button class="btn btn-secondary">Event erstellen</button></a>
    </div>
    <div v-if="node.config" class="form-group">
      <label>Event:</label>
      <ul class="list-group">
        <li class="list-group-item evsource"><b>Source:</b>&nbsp;{{ node.config.source }}</li>
        <li class="list-group-item evgroup"><b>Group:</b>&nbsp;{{ node.config.group }}</li>
        <li class="list-group-item evevent"><b>Event:</b>&nbsp;{{ node.config.event }}</li>
      </ul>
    </div>
    <BFlowEventSelector @selected="updateEvent"/>
  </div>
</template>

<script>
import BFlowEventSelector from '@/components/digitalfirm/BFlowEventSelector.vue'

export default {
  name: 'BFlowStartProps',
  props: ["node"],
  components: {
    BFlowEventSelector
  },
  watch: {
    "node": function(node) {
      console.log('watch node');
      console.log(node);
    }
  },
  mounted: function() {
    console.log('mount start node view');
  },
  methods: {
    selectEvent() {
      console.log('open event');
      this.$bvModal.show('bflowEventSource');
    },
    updateEvent(evt) {
      console.log(evt);
      this.node.config = this.node.config || {};
      this.node.config = evt;
    },
    updateData() {
      this.$emit('update');
    }
  }
}
</script>

<style scoped>
li.evsource {
  background-color: #dde;
}
li.evgroup {
  background-color: #ded;
}
li.evevent {
  background-color: #edd;
}
</style>
